<template>
  <nav class="navbar navbar-expand-lg sticky-top navbar-light bg-light">
    <div class="container d-flex flex-column flex-md-row justify-content-end">



    </div>
  </nav>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'MainNav',
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('/')
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  }
}
</script>

<style scoped>
  .nav-link {
    color: #999;
  }
  .nav-link:hover {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainNav.vue